import React from "react";

export default function Section13() {
  const processSteps = [
    {
      title: "Discover",
      description: "We dive deep into understanding your business, audience, and goals.",
    },
    {
      title: "Design",
      description: "We create wireframes and UI concepts that align with your brand and best practices.",
    },
    {
      title: "Develop",
      description: "Our developers build the frontend and backend with full responsiveness.",
    },
    {
      title: "Test",
      description: "Rigorous cross-device testing and speed optimization ensure a flawless experience.",
    },
    {
      title: "Launch and Support",
      description: "We handle the go-live process and offer continuous optimization and post-launch support.",
    },
  ];

  return (
    <div className="w-full Section13">
      <div className="md:w-[80%] w-[90%] text-center pt-5 mx-auto">
        <h2 className="text-[26px] md:text-[34px] leading-[40px] font-bold pb-[2%] my-[0.67em] -mb-[1%]">
          What to Expect When You Work With Us
        </h2>
        <p className="text-[#373737] text-sm md:text-base leading-[22px] mb-8">
          Our Shopify development process in Dubai is designed for clarity, collaboration, and high-quality output. We guide you through every phase of your Shopify store’s development:
        </p>

        <div className="boxes flex flex-wrap justify-center gap-x-[2%] gap-y-[19px] md:gap-y-[30px] w-[85%] mx-auto">
          {processSteps.map((step, index) => (
            <div
              key={index}
              className={`w-full xs:w-[45%] md:w-[30%] p-[10%] xs:p-[3%] rounded-[8px] ${index % 2 === 0 ? "bg-[#E42E35] text-white" : "bg-[#F5F5F5] text-[#373737]"
                }`}
            >
              <h3 className="md:text-[25px] text-[20px] font-bold leading-[30px] mb-3">
                {step.title}
              </h3>
              <p className="text-xs md:text-sm leading-[22px] font-open">
                {step.description}
              </p>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
